import { render, staticRenderFns } from "./SearchServiceWrapper.vue?vue&type=template&id=3452b988"
import script from "./SearchServiceWrapper.vue?vue&type=script&lang=js"
export * from "./SearchServiceWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3452b988')) {
      api.createRecord('3452b988', component.options)
    } else {
      api.reload('3452b988', component.options)
    }
    module.hot.accept("./SearchServiceWrapper.vue?vue&type=template&id=3452b988", function () {
      api.rerender('3452b988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/compensatoryService/SearchServiceWrapper.vue"
export default component.exports